import React from "react";
import { AssessmentManagement } from "@components/Assessment";

export default function AssessmentIndex() {
  return <AssessmentManagement />;
}
